/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {ConfirmModalComponent} from '../confirm-modal.component';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ExistingFileModalModel} from './existing-file-modal.model';
import {AlertNotificationSeverity} from '../../../../alert-notification-severity.model';

@Component({
    selector: 'app-existing-file-modal',
    templateUrl: './existing-file-modal.component.html',
    styleUrls: ['../confirm-modal.component.css', './existing-file-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExistingFileModalComponent extends ConfirmModalComponent {
    // FIXME: CTWILS-2360 - Move the primary and secondary action inputs up on the inheritance
    @Input() primaryActionDisabled = false;
    @Input() secondaryActionDisabled = false;
    @Input() tertiaryActionDisabled = false;
    @Input() tertiaryButtonText: string;
    @Output() tertiaryEvent = new EventEmitter<any>();

    constructor(public activeModal: NgbActiveModal) {
        super(activeModal);
    }

    // FIXME: CTWILS-2360 - change return typedef to void
    initModal(model: ExistingFileModalModel): any {
        super.initModal(model);
        this.tertiaryButtonText = model.tertiaryButtonText;
    }

    // FIXME: CTWILS-2360 - move this to the topmost component in the inheritance
    getHeaderClass(): string {
        switch (this.alertNotificationSeverity) {
            case AlertNotificationSeverity.INFORMATION:
                return 'modal-header-information';
            case AlertNotificationSeverity.WARNING:
                return 'modal-header-warning';
            case AlertNotificationSeverity.ERROR:
                return 'modal-header-error';
        }
    }

    clickTertiaryButton(): void {
        this.tertiaryEvent.emit();
        this.activeModal.dismiss();
    }

    // FIXME: CTWILS-2360 - Merge this method with the original one and rename it to isPrimaryButtonDisabled
    disablePrimaryButton(): boolean {
        return this.primaryActionDisabled || super.disablePrimaryButton();
    }

    // FIXME: CTWILS-2360 - Move the method up on the inheritance
    isSecondaryButtonDisabled(): boolean {
        return this.secondaryActionDisabled;
    }

    isTertiaryButtonDisabled(): boolean {
        return this.tertiaryActionDisabled;
    }
}
